import * as React from "react";
import PropTypes from "prop-types";
import * as Theme from "../../../app/Theme";
import HumanitarianHealthLogoWhiteText from "../../../img/HumanitarianHealthLogoWhiteTextHorizontal.png";
import TAppBar from "../../APP/TAppBar";
import HLAppBarCustom from "./HLAppBarCustom";
import * as HLConst from "../NonVisual/HLConst";
import * as GBConst from "../../GB/GBConst";

class HLAppBar extends React.Component {
    static propTypes = {
        onDrawerChange: PropTypes.func,
        pageID: PropTypes.string,
        onPageChange: PropTypes.func,
        titleStyle: PropTypes.object,
        screenSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        onSideBarArrowClick: PropTypes.func,
        showAboutDialog: PropTypes.bool,
        onShowAboutDialogChange: PropTypes.func,
    };

    static defaultProps = {
        onDrawerChange: () => console.log("onDrawerChange"),
        pageID: "",
        onPageChange: () => console.log("onPageChange"),
        titleStyle: {},
        screenSize: 0,
        onSideBarArrowClick: () => console.log("onSideBarArrowClick"),
        showAboutDialog: false,
        onShowAboutDialogChange: () => console.log("onPageChange"),
    };

    onHamburgerClick = () => {
        this.props.onSideBarArrowClick();
    };

    render() {
        /* props */
        const props = this.props;
        const screenSize = props.screenSize;

        const appBarLogoHeight = Theme.HL_JHU_LogoMinHeight;

        let caption = HLConst.appTitle + " (" + HLConst.appTitleAbbr + ")";
        let img = null;

        if (screenSize !== GBConst.lgScreen) {
            caption = HLConst.appTitleAbbr;
        }

        if (screenSize !== GBConst.smScreen) {
            img = (
                <img
                    onClick={() => this.props.onPageChange(HLConst.introForm)}
                    style={{
                        cursor: "pointer",
                        height: appBarLogoHeight,
                        //marginTop : 5,
                        minWidth: Theme.HL_JHU_LogoMinWidth, //markH
                        width: Theme.HL_JHU_LogoMinWidth, // markH
                    }}
                    src={HumanitarianHealthLogoWhiteText}
                    alt={"HumanitarianHealthLogoWhiteText"}
                />
            );
        }

        return (
            <TAppBar
                caption={caption}
                showHamburger={true}
                onHamburgerClick={this.onHamburgerClick}
                style={{
                    ...Theme.vCenteredStyle,
                    //'minHeight' : this.props.height,
                    height: appBarLogoHeight,
                    minHeight: 65, //markH
                    background: Theme.HL_PrimaryColor, //Theme.whiteColor,
                    color: Theme.whiteColor, //Theme.HL_PrimaryColor,
                    fontWeight: "bold",
                }}
                logo={img}
                onTitleClick={() => this.props.onPageChange(HLConst.introForm)}
                titleStyle={this.props.titleStyle}
            >
                <HLAppBarCustom
                    onDrawerChange={this.props.onDrawerChange}
                    pageID={this.props.pageID}
                    onPageChange={this.props.onPageChange}
                    showAboutDialog={this.props.showAboutDialog}
                    onShowAboutDialogChange={this.props.onShowAboutDialogChange}
                />
            </TAppBar>
        );
    }
}

export default HLAppBar;
